// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Contracts_tableHead__1gk3n"};